module.exports = __webpack_public_path__ + "img/xiaolachuxing.f7e03166.png";